class TokenService {
  static getAuthToken() {
    return sessionStorage.getItem('authToken');
  }

  static setAuthToken(token) {
    if (token) {
      sessionStorage.setItem('authToken', token);
    } else {
      sessionStorage.removeItem('authToken');
    }
  }

  static getAuthHeader() {
    const token = this.getAuthToken();
    return token ? `Bearer ${token}` : null;
  }

  static getTenantId() {
    return sessionStorage.getItem('X-TenantId');
  }

  static setTenantId(id) {
    if (id) {
      sessionStorage.setItem('X-TenantId', id);
    } else {
      sessionStorage.removeItem('X-TenantId');
    }
  }

  static getTenantName() {
    return sessionStorage.getItem('tenantName');
  }

  static setTenantName(name) {
    if (name) {
      sessionStorage.setItem('tenantName', name);
    } else {
      sessionStorage.removeItem('tenantName');
    }
  }

  static clearAll() {
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('X-TenantId');
    sessionStorage.removeItem('tenantName');
    localStorage.removeItem('authToken');
    localStorage.removeItem('tenantName');
  }

  static isAuthenticated() {
    const token = this.getAuthToken();
    return !!token; // returns true if token exists, false otherwise
  }
}

export default TokenService;